import {createSlice} from '@reduxjs/toolkit';

export const AdminUserReducer = createSlice({
    name: 'adminUser',
    initialState: {adminUser: []},
    
    reducers: {
        setAdminUser: (state:any,action:any) => {
            const users = action.payload
            return {
                ...state, adminUser:users
            }
        },
        addAdminUser:(state:any, action:any) => {
            const users = action.payload;
            return {
                ...state, adminUser: [
                    users, ...state.adminUser
                ]
            }
        },
        editAdminUser:(state: any, action: any) => {
            const user = action.payload;
            const newUsers = state.adminUser.map((eUser: any) => eUser.Email == user.Email ? user : eUser); 
            return {
                ...state, adminUser: newUsers
            }
        }
    }
})

export const {setAdminUser, addAdminUser, editAdminUser} = AdminUserReducer.actions;
export default AdminUserReducer.reducer;